import type { AttendanceSectionList } from "../types";

export function mergeAttendanceSections(pages: AttendanceSectionList[]): AttendanceSectionList {
	const merged: AttendanceSectionList = [];

	for (const sections of pages) {
		for (const section of sections) {
			const existing = merged.find((s) => s.title === section.title);
			if (existing) {
				existing.data.push(...section.data);
			} else {
				merged.push({ title: section.title, data: [...section.data] });
			}
		}
	}

	return merged;
}
